export default __webpack_public_path__ + "static/media/happy.13fde7d6.mp3";